<template>
    <div>
        <!--基本信息修改对比-->
        <el-row>
            <el-table :data="basic_compare" border key="2">
                <el-table-column label="修订项(学校基本信息配置)" prop="name"></el-table-column>
                <el-table-column label="修订后" prop="after">
                    <template slot-scope="scope">
                        <span v-html="scope.row.after"></span>
                    </template>
                </el-table-column>
                <el-table-column label="修改前" prop="before">
                    <template slot-scope="scope">
                        <span v-html="scope.row.before"></span>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>
        <!--车厢对比-->
        <el-table :data="compare" border key="1">
            <el-table-column :label="title" prop="name"></el-table-column>
            <el-table-column label="修订后" prop="after">
                <template slot-scope="scope">
                    <span v-html="scope.row.after"></span>
                </template>
            </el-table-column>
            <el-table-column label="修改前" prop="before">
                <template slot-scope="scope">
                    <span v-html="scope.row.before"></span>
                </template>
            </el-table-column>
        </el-table>
        <!--学校风控对比-->
        <el-row>
            <el-table :data="risk_compare" border key="2">
                <el-table-column label="修订项(学校风控配置)" prop="name"></el-table-column>
                <el-table-column label="修订后" prop="after">
                    <template slot-scope="scope">
                        <span v-html="scope.row.after"></span>
                    </template>
                </el-table-column>
                <el-table-column label="修改前" prop="before">
                    <template slot-scope="scope">
                        <span v-html="scope.row.before"></span>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>
    </div>
</template>

<script>
    import Params from "~/config/params";
    import Time from '~/common/time';

    export default {
        name: "xwt",
        props: {
            edit_content: {
                required: true
            }
        },
        created() {
            this.getCompare();
            this.getRiskCompare();
            this.getBasicCompare();
        },
        data() {
            return {
                title: '修订项',
                compare: [],
                risk_compare: [],
                basic_compare: [],
                expire_types: [
                    '永久',
                    '7天',
                    '30天',
                    '1分钟测试使用',
                    '1天'
                ]
            }
        },
        methods: {
            getBasicCompare() {

                let order_type = {
                    name: '订单类型',
                    before: '',
                    after: ''
                };
                let start = {
                    name: '开始时间',
                    before: '',
                    after: ''
                };
                let end = {
                    name: '结束时间',
                    before: '',
                    after: ''
                };
                if (typeof this.edit_content.before_content === 'object') {
                    let type = Params.getType().find(item=>{return item.value==this.edit_content.before_content.type});
                    order_type.before = type.label;
                    start.before = Time.asDateDay(this.edit_content.before_content.start_at);
                    end.before = Time.asDateDay(this.edit_content.before_content.end_at);
                };
                let type = Params.getType().find(item=>{return item.value==this.edit_content.content.type});
                order_type.after = type.label;
                start.after = Time.asDateDay(this.edit_content.content.start_at);
                end.after = Time.asDateDay(this.edit_content.content.end_at);

                if (order_type.before !== order_type.after) order_type.after = "<span style='color: red'>" + order_type.after + "</span>";
                if (start.before !== start.after) start.after = "<span style='color: red'>" + start.after + "</span>";
                if (end.before !== end.after) end.after = "<span style='color: red'>" + end.after + "</span>";

                this.basic_compare.push(order_type);
                this.basic_compare.push(start);
                this.basic_compare.push(end);
            },

            getRiskCompare() {
                this.setExpireType();
                this.setRiskDay();
                this.setRiskDaySingle();
                this.setRiskCoin();
                this.setRiskCoinSingle();
                this.setRiskAll();
                this.setRiskAllDay();
            },
            getCompare() {
                this.title = this.title + " (车厢ID:" + this.edit_content.content.box_setting.id + ")";
                this.setDay();
                this.setAll();
                this.setCoin();
                this.setIp();
                this.setBatch();
            },
            setExpireType() {
                let day_down = {
                    name: '修改有效期',
                    before: '',
                    after: ''
                };
                if(this.edit_content.content.expire_type != ''){
                    let expire_at = '';
                    if(this.edit_content.content.expire_type == 1){
                        expire_at = Params.timestampToDateTime(this.edit_content.created_at + 86400 * 7);
                    }else if(this.edit_content.content.expire_type == 2){
                        expire_at = Params.timestampToDateTime(this.edit_content.created_at + 86400 * 30);
                    }else if(this.edit_content.content.expire_type == 3){
                        expire_at = Params.timestampToDateTime(this.edit_content.created_at + 60);
                    }else if(this.edit_content.content.expire_type == 4){
                        expire_at = Params.timestampToDateTime(this.edit_content.created_at + 86400);
                    }
                    day_down.after = "<span style='color: red'>" + this.expire_types[this.edit_content.content.expire_type] + "</span> 到期时间：" + expire_at;
                }
                this.risk_compare.push(day_down);
            },
            setRiskDay() {
                let day_down = {
                    name: '下载次数限制（日下载次数设置）',
                    before: '',
                    after: ''
                };
                let before = '';
                if (typeof this.edit_content.before_content === 'object') {
                    before += '总：' + this.edit_content.before_content.day_time_setting.all;
                    before += ' 精:' + this.edit_content.before_content.day_time_setting.jing;
                    before += ' 普:' + this.edit_content.before_content.day_time_setting.pu;
                    before += ' 特:' + this.edit_content.before_content.day_time_setting.te;
                }
                let after = '总：' + this.edit_content.content.day_time_setting.all;
                after += ' 精:' + this.edit_content.content.day_time_setting.jing;
                after += ' 普:' + this.edit_content.content.day_time_setting.pu;
                after += ' 特:' + this.edit_content.content.day_time_setting.te;
                if (before !== after) {
                    after = "<span style='color: red'>" + after + "</span>";
                }
                day_down.before = before;
                day_down.after = after;
                this.risk_compare.push(day_down);
            },
            setRiskDaySingle() {
                let day_down = {
                    name: '单个账号下载次数限制（日下载次数设置）',
                    before: '',
                    after: ''
                };
                let before = '';
                if (typeof this.edit_content.before_content === 'object') {
                    before += '总：' + this.edit_content.before_content.single_account_time_setting.all;
                    before += ' 精:' + this.edit_content.before_content.single_account_time_setting.jing;
                    before += ' 普:' + this.edit_content.before_content.single_account_time_setting.pu;
                    before += ' 特:' + this.edit_content.before_content.single_account_time_setting.te;
                }
                ;
                let after = '总：' + this.edit_content.content.single_account_time_setting.all;
                after += ' 精:' + this.edit_content.content.single_account_time_setting.jing;
                after += ' 普:' + this.edit_content.content.single_account_time_setting.pu;
                after += ' 特:' + this.edit_content.content.single_account_time_setting.te;
                if (before !== after) {
                    after = "<span style='color: red'>" + after + "</span>";
                }
                day_down.before = before;
                day_down.after = after;
                this.risk_compare.push(day_down);
            },
            setRiskCoin() {
                let day_down = {
                    name: '充值学币数量（学币使用设置）',
                    before: '',
                    after: ''
                };
                let before = '';
                if (typeof this.edit_content.before_content === 'object') {
                    before += '充值学币数量：' + this.edit_content.before_content.coin_setting.sums;
                    before += ' 精:' + this.edit_content.before_content.coin_setting.jing;
                    before += ' 普:' + this.edit_content.before_content.coin_setting.pu;
                    before += ' 特:' + this.edit_content.before_content.coin_setting.te;
                }
                ;
                let after = '充值学币数量：' + this.edit_content.content.coin_setting.sums;
                after += ' 精:' + this.edit_content.content.coin_setting.jing;
                after += ' 普:' + this.edit_content.content.coin_setting.pu;
                after += ' 特:' + this.edit_content.content.coin_setting.te;
                if (before !== after) {
                    after = "<span style='color: red'>" + after + "</span>";
                }
                day_down.before = before;
                day_down.after = after;
                this.risk_compare.push(day_down);
            },
            setRiskCoinSingle() {
                let day_down = {
                    name: '单个账号使用学币数量（学币使用设置）',
                    before: '',
                    after: ''
                };
                let before = '';
                if (typeof this.edit_content.before_content === 'object') {
                    before += '单个账号使用学币数量：' + this.edit_content.before_content.single_coin_setting.sums;
                    before += ' 精:' + this.edit_content.before_content.single_coin_setting.jing;
                    before += ' 普:' + this.edit_content.before_content.single_coin_setting.pu;
                    before += ' 特:' + this.edit_content.before_content.single_coin_setting.te;
                }
                ;
                let after = '单个账号使用学币数量：' + this.edit_content.content.single_coin_setting.sums;
                after += ' 精:' + this.edit_content.content.single_coin_setting.jing;
                after += ' 普:' + this.edit_content.content.single_coin_setting.pu;
                after += ' 特:' + this.edit_content.content.single_coin_setting.te;
                if (before !== after) {
                    after = "<span style='color: red'>" + after + "</span>";
                }
                day_down.before = before;
                day_down.after = after;
                this.risk_compare.push(day_down);
            },
            setRiskAll() {
                let day_down = {
                    name: '下载次数限制（总下载次数设置）',
                    before: '',
                    after: ''
                };
                let before = '';
                if (typeof this.edit_content.before_content === 'object') {
                    before += '总：' + this.edit_content.before_content.day_time_all_setting.all;
                    before += ' 精:' + this.edit_content.before_content.day_time_all_setting.jing;
                    before += ' 普:' + this.edit_content.before_content.day_time_all_setting.pu;
                    before += ' 特:' + this.edit_content.before_content.day_time_all_setting.te;
                }
                ;
                let after = '总：' + this.edit_content.content.day_time_all_setting.all;
                after += ' 精:' + this.edit_content.content.day_time_all_setting.jing;
                after += ' 普:' + this.edit_content.content.day_time_all_setting.pu;
                after += ' 特:' + this.edit_content.content.day_time_all_setting.te;
                if (before !== after) {
                    after = "<span style='color: red'>" + after + "</span>";
                }
                day_down.before = before;
                day_down.after = after;
                this.risk_compare.push(day_down);
            },
            setRiskAllDay() {
                let day_down = {
                    name: '单个账号下载次数限制（总下载次数设置）',
                    before: '',
                    after: ''
                };
                let before = '';
                if (typeof this.edit_content.before_content === 'object') {
                    before += '总：' + this.edit_content.before_content.single_account_time_all_setting.all;
                    before += ' 精:' + this.edit_content.before_content.single_account_time_all_setting.jing;
                    before += ' 普:' + this.edit_content.before_content.single_account_time_all_setting.pu;
                    before += ' 特:' + this.edit_content.before_content.single_account_time_all_setting.te;
                }
                ;
                let after = '总：' + this.edit_content.content.single_account_time_all_setting.all;
                after += ' 精:' + this.edit_content.content.single_account_time_all_setting.jing;
                after += ' 普:' + this.edit_content.content.single_account_time_all_setting.pu;
                after += ' 特:' + this.edit_content.content.single_account_time_all_setting.te;
                if (before !== after) {
                    after = "<span style='color: red'>" + after + "</span>";
                }
                day_down.before = before;
                day_down.after = after;
                this.risk_compare.push(day_down);
            },
            setDay() {
                let day = {
                    name: '日下载总次数',
                    before: '',
                    after: ''
                };
                let before = '';
                if (typeof this.edit_content.before_content === 'object') {
                    before += '总：' + this.edit_content.before_content.day.all;
                    before += ' 精:' + this.edit_content.before_content.day.jing;
                    before += ' 普:' + this.edit_content.before_content.day.pu;
                    before += ' 特:' + this.edit_content.before_content.day.te;
                }
                ;
                let after = '总：' + this.edit_content.content.box_setting.day.all;
                after += ' 精:' + this.edit_content.content.box_setting.day.jing;
                after += ' 普:' + this.edit_content.content.box_setting.day.pu;
                after += ' 特:' + this.edit_content.content.box_setting.day.te;
                if (before !== after) {
                    after = "<span style='color: red'>" + after + "</span>";
                }
                day.before = before;
                day.after = after;
                this.compare.push(day);
            },
            setAll() {
                let All = {
                    name: '总下载次数',
                    before: '',
                    after: ''
                };
                let before = '';
                if (typeof this.edit_content.before_content === 'object') {
                    before = '总：' + this.edit_content.before_content.all.all;
                    before += ' 精:' + this.edit_content.before_content.all.jing;
                    before += ' 普:' + this.edit_content.before_content.all.pu;
                    before += ' 特:' + this.edit_content.before_content.all.te;
                }
                let after = '总：' + this.edit_content.content.box_setting.all.all;
                after += ' 精:' + this.edit_content.content.box_setting.all.jing;
                after += ' 普:' + this.edit_content.content.box_setting.all.pu;
                after += ' 特:' + this.edit_content.content.box_setting.all.te;
                if (before !== after) {
                    after = "<span style='color: red'>" + after + "</span>";
                }
                All.before = before;
                All.after = after;
                this.compare.push(All);
            },
            setCoin() {
                let coin = {
                    name: '学币使用限制',
                    before: '',
                    after: ''
                };
                let before = '';
                if (typeof this.edit_content.before_content === 'object') {
                    before += '总：' + this.edit_content.before_content.coin;
                    before += ' 精:' + this.edit_content.before_content.jing;
                    before += ' 普:' + this.edit_content.before_content.pu;
                    before += ' 特:' + this.edit_content.before_content.te;
                }
                let after = '总：' + this.edit_content.content.box_setting.coin;
                after += ' 精:' + this.edit_content.content.box_setting.jing;
                after += ' 普:' + this.edit_content.content.box_setting.pu;
                after += ' 特:' + this.edit_content.content.box_setting.te;
                if (before !== after) {
                    after = "<span style='color: red'>" + after + "</span>";
                }
                coin.before = before;
                coin.after = after;
                this.compare.push(coin);
            },
            setIp() {
                let ip = {
                    name: '限制IP段',
                    before: '',
                    after: ''
                };
                let before = '';
                let after = '';
                if (this.edit_content.content.box_setting.ips.length > 0) {
                    this.edit_content.content.box_setting.ips.map(i => {
                        after += '开始IP:' + i.start_ip + " 结束IP:" + i.end_ip + '<br/>';
                    });
                }
                if (typeof this.edit_content.before_content === 'object') {
                    this.edit_content.before_content.ips.map(i => {
                        before += '开始IP:' + i.start_ip + " 结束IP:" + i.end_ip + '<br/>';
                    });
                }
                if (before !== after) {
                    after = "<span style='color: red'>" + after + "</span>";
                }
                ip.before = before;
                ip.after = after;
                this.compare.push(ip);
            },

            setBatch() {
                this.edit_content.content.box_setting.batch.map(i => {
                    if (i.subject_id === 0) return;
                    let subject = {
                        name: '',
                        before: '',
                        after: ''
                    }
                    subject.name = i.subject_name;
                    let before = '';
                    let after = '';

                    after += '小学 普:' + i.config.primary.pu + " 精:" + i.config.primary.jing + " 特:" + i.config.primary.te + '<br/>';
                    after += '初中 普:' + i.config.middle.pu + " 精:" + i.config.middle.jing + " 特:" + i.config.middle.te + "<br/>";
                    after += '高中 普:' + i.config.high.pu + " 精:" + i.config.high.jing + " 特:" + i.config.high.te + '<br/>';
                    if (typeof this.edit_content.before_content.batch != 'undefined') {
                        let content = this.edit_content.before_content.batch.find(j => {
                            return j.subject_id == i.subject_id;
                        });
                        before += '小学 普:' + content.config.primary.pu + " 精:" + content.config.primary.jing + " 特:" + content.config.primary.te + '<br/>';
                        before += '初中 普:' + content.config.middle.pu + " 精:" + content.config.middle.jing + " 特:" + content.config.middle.te + '<br/>';
                        before += '高中 普:' + content.config.high.pu + " 精:" + content.config.high.jing + " 特:" + content.config.high.te + '<br/>';
                    }
                    if (before !== after) {
                        after = "<span style='color: red'>" + after + "</span>";
                    }
                    subject.before = before;
                    subject.after = after;
                    this.compare.push(subject);

                });
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/order/recoder/xwt.vue